import React from 'react'
import useSearch from '../../../context/search/useSearch'
import SearchResultsProductItem from './Components/SearchResultProductItem'



interface ISearchResultsProductsComponent {
  dataSet: DOMStringMap
}

const SearchResultsProducts: React.FC<ISearchResultsProductsComponent> = ({dataSet}): JSX.Element => {

  const {langTitle} = dataSet

  const {quickSearchResultsProducts} = useSearch()

  if (quickSearchResultsProducts && !quickSearchResultsProducts.length) return null

  return (
    <React.Fragment>
      <div className={`sf-results sf-results-products ${quickSearchResultsProducts && quickSearchResultsProducts.length && 'sf-results-loaded'}`}>
        {(quickSearchResultsProducts && quickSearchResultsProducts.length) && <React.Fragment>

          {langTitle && <h5 className={'sf-results-title'}>{langTitle}</h5>}

          <div className={'sf-results-products-items'}>
            {quickSearchResultsProducts
              .map((product, index) => {
                return (
                  <SearchResultsProductItem key={index} product={product}></SearchResultsProductItem>
                )
              })}
          </div>
        </React.Fragment>}
      </div>
    </React.Fragment>
  )
}

export default SearchResultsProducts